// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2BxUw","buttons":"PendingPaymentAlert_buttons__IElTS"};